export class TransferirContratoFormModel {
  constructor(
    public cnpj: string = '',
  ) { }
}